var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGroupAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32837_163748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 15.7499V14.2499C17.7495 13.5852 17.5283 12.9395 17.121 12.4141C16.7138 11.8888 16.1436 11.5136 15.5 11.3474",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 15.75V14.25C13.25 13.4544 12.9339 12.6913 12.3713 12.1287C11.8087 11.5661 11.0456 11.25 10.25 11.25H4.25C3.45435 11.25 2.69129 11.5661 2.12868 12.1287C1.56607 12.6913 1.25 13.4544 1.25 14.25V15.75",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.34741C13.1453 2.51264 13.7173 2.88794 14.1257 3.41415C14.5342 3.94035 14.7559 4.58753 14.7559 5.25366C14.7559 5.91979 14.5342 6.56697 14.1257 7.09318C13.7173 7.61939 13.1453 7.99469 12.5 8.15991",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.25C8.90685 8.25 10.25 6.90685 10.25 5.25C10.25 3.59315 8.90685 2.25 7.25 2.25C5.59315 2.25 4.25 3.59315 4.25 5.25C4.25 6.90685 5.59315 8.25 7.25 8.25Z",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32837_163748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroupAdd);
export default __webpack_public_path__ + "static/media/ic_group_add.7b232597b57c7c0c02497ad0fdd2c136.svg";
export { ForwardRef as ReactComponent };